module.exports = __webpack_public_path__ + "img/Draft.8589fe6b.svg";